<template>
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 14.9829L4.62499 14.9913C5.38332 14.9913 6.09166 14.6163 6.50833 13.9913L11.8333 6.00796C12.25 5.38296 12.9583 4.99961 13.7167 5.00795L17.5083 5.02463"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M15.834 16.651L17.5007 14.9844"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M7.40835 7.18347L6.50833 5.93347C6.08333 5.34181 5.39999 4.99181 4.67499 5.00015L2.5 5.00849"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M10.8086 12.8164L11.8253 14.1247C12.2503 14.6747 12.9169 14.9997 13.6169 14.9997L17.5086 14.9831"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      d="M17.5007 5.01823L15.834 3.35156"
      stroke="currentcolor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
